import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { SdSwiperComponent } from '@sdvor/shared/ui';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { MediaModule, PageComponentModule } from '@spartacus/storefront';
import { SdBannerCarouselComponent } from './banner-carousel.component';

@NgModule({
  imports: [NgIf, AsyncPipe, SdSwiperComponent, MediaModule, PageComponentModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.RotatingImagesComponent]: {
          component: SdBannerCarouselComponent,
        },
        [PromoCmsComponents.RosaRotatingImagesComponent]: {
          component: SdBannerCarouselComponent,
        },
      },
    }),
  ],
  declarations: [SdBannerCarouselComponent],
})
export class SdBannerCarouselModule {}
